import { render, staticRenderFns } from "./menus.vue?vue&type=template&id=70cf5291&scoped=true"
import script from "./menus.vue?vue&type=script&lang=js"
export * from "./menus.vue?vue&type=script&lang=js"
import style0 from "./menus.vue?vue&type=style&index=0&id=70cf5291&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cf5291",
  null
  
)

export default component.exports